module.exports = __webpack_public_path__ + "img/silk.be5030ca.webp";